import { useInfiniteQuery } from '@tanstack/react-query'
import { useStore } from 'react-redux'
import { appendQueryParamsToURL, getCredentialsConfig } from '../common/src/helpers/requestHelper'
import { PaginatedResponse } from '../types/apiTypes'
import type { Webinar } from '../types/webinar'

export const useWebinars = (enabled = true) => {
  const store = useStore()

  return useInfiniteQuery({
    queryKey: ['webinars'],
    queryFn: async ({ pageParam = '' }) => {
      const response = await fetch(appendQueryParamsToURL(pageParam || '/api/v1/webinar/')(store.getState()), {
        credentials: getCredentialsConfig(),
      })
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return (await response.json()) as PaginatedResponse<Webinar>
    },
    getNextPageParam: lastPage => lastPage.meta.next,
    initialPageParam: '',
    select: data => data.pages.flatMap(page => page.objects),
    staleTime: 30 * 60 * 1000,
    enabled,
  })
}
